import { Form } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { ActionEnum, getDateFormat } from '../../../../../common'
import {
  ManageModalComponent,
  ManageModalFooterComponent,
  NumberFormat,
} from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'

const StyledFormItem = styled(Form.Item)`
  margin-top: 5px;
`

const StyledLabel = styled.span`
  font-weight: bold;
`

export const ManageTransactionModalComponent: React.FC = () => {
  const { management } = useSelector((state: RootState) => state.common)
  const { language } = useSelector((state: RootState) => state.language)
  const { selectedTransaction } = useSelector(
    (state: RootState) => state.transaction
  )

  const readOnlyMode = React.useMemo(
    () => [ActionEnum.VIEW, ActionEnum.DELETE].includes(management.action),
    [management]
  )

  const body = readOnlyMode && (
    <Form>
      {selectedTransaction && (
        <>
          <StyledFormItem
            label={
              <StyledLabel>{translate('transaction.id', language)}</StyledLabel>
            }
          >
            {selectedTransaction.id}
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.time', language)}
              </StyledLabel>
            }
          >
            {getDateFormat(selectedTransaction.time, true)}
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.station', language)}
              </StyledLabel>
            }
          >
            {selectedTransaction.pumpShift.pump.tank.station.name}
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.shift', language)}
              </StyledLabel>
            }
          >
            {selectedTransaction.pumpShift.shift.name}
          </StyledFormItem>

          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.pump', language)}
              </StyledLabel>
            }
          >
            {selectedTransaction.pumpShift.pump.name}
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.unitPrice', language)}
              </StyledLabel>
            }
          >
            <NumberFormat
              value={selectedTransaction.unitPrice}
              suffixKey="common.moneyType"
            />
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.volume', language)}
              </StyledLabel>
            }
          >
            <NumberFormat
              value={selectedTransaction.volume}
              suffixKey="common.unitType"
            />
          </StyledFormItem>
          <StyledFormItem
            label={
              <StyledLabel>
                {translate('transaction.amount', language)}
              </StyledLabel>
            }
          >
            <NumberFormat
              value={selectedTransaction.totalAmount}
              suffixKey="common.moneyType"
            />
          </StyledFormItem>
        </>
      )}
      <ManageModalFooterComponent />
    </Form>
  )

  return <ManageModalComponent body={body} />
}
